import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './store';

export interface WishlistItem {
    productId: string;
    name: string;
    brand: string;
    price: number;
    image: string;
    category: string;
}

interface WishlistState { items: WishlistItem[] }

function loadFromStorage(): WishlistItem[] {
    try {
        const raw = localStorage.getItem('wishlist');
        return raw ? JSON.parse(raw) : [];
    } catch { return []; }
}

function saveToStorage(items: WishlistItem[]) {
    try { localStorage.setItem('wishlist', JSON.stringify(items)); } catch {}
}

const wishlistSlice = createSlice({
    name: 'wishlist',
    initialState: { items: loadFromStorage() } as WishlistState,
    reducers: {
        toggleWishlist(state, action: PayloadAction<WishlistItem>) {
            const idx = state.items.findIndex(i => i.productId === action.payload.productId);
            if (idx >= 0) {
                state.items.splice(idx, 1);
            } else {
                state.items.push(action.payload);
            }
            saveToStorage(state.items);
        },
        removeFromWishlist(state, action: PayloadAction<string>) {
            state.items = state.items.filter(i => i.productId !== action.payload);
            saveToStorage(state.items);
        },
    },
});

export const { toggleWishlist, removeFromWishlist } = wishlistSlice.actions;
export default wishlistSlice.reducer;

export const selectIsWishlisted = (productId: string) => (state: RootState) =>
    state.wishlist.items.some(i => i.productId === productId);

export const selectWishlistCount = (state: RootState) => state.wishlist.items.length;
